import { render } from "./VorlesungsBox.vue?vue&type=template&id=2818f2c8"
import script from "./VorlesungsBox.vue?vue&type=script&lang=js"
export * from "./VorlesungsBox.vue?vue&type=script&lang=js"

import "./VorlesungsBox.vue?vue&type=style&index=0&id=2818f2c8&lang=css"
script.render = render

export default script